// extracted by mini-css-extract-plugin
export default {"loadingContainer":"j8XIDZHSdcK7hI9l3Mn2","buttonGroup":"SthsFzFWXGQ9CuVz3cam","adminBox":"AgJtGK1_zLch0CzYNJ8j","taxNotice":"tUMVJQXEL8ddyJAYWgKX"};